import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ModalController, ToastController } from '@ionic/angular';
import { DateHelperService } from 'src/app/core/helpers/date-helper/date-helper.service';
import { FormHelperService } from 'src/app/core/helpers/form-helper/form-helper.service';
import { LinecardElement, LinecardElementComment } from 'src/app/core/models/linecard.model';
import { LinecardService } from 'src/app/core/services/linecard/linecard.service';

@Component({
	templateUrl: './appointment-linecard-comment-modal.component.html',
	styleUrls: ['./appointment-linecard-comment-modal.component.scss']
})
export class AppointmentLinecardCommentModalComponent implements OnInit {

	@Input()
	linecardEl: LinecardElement;

	@Input()
	linecardDesc: string;

	@Input()
	ticketId: number;

	pageTitle = 'Add Element Change Comment';
	subject: string;

	form: FormGroup;
	isFormSubmitted = null as boolean;

	constructor(
		private modalController: ModalController,
		private formBuilder: FormBuilder,
		private formHelper: FormHelperService,
		private toastController: ToastController,
		private dateHelper: DateHelperService,
		private linecardService: LinecardService,
	) { }

	ngOnInit(): void {
		this.subject = `Change Comment for ${this.linecardEl.type} - ${this.linecardEl.desc}`;
		this.form = this.formBuilder.group({
			comment: ['', Validators.compose([
				Validators.required,
				Validators.minLength(5),
			])],
		});
	}

	onClickSave() {
		this.isFormSubmitted = false;
		this.form = this.formHelper.markAsTouched(this.form);
		if (this.form.invalid) {
			this.formHelper.alertUser();
			return;
		}
		this.isFormSubmitted = true;

		const separator = ` || '_' || `;
		const comment = {
			ticketId: this.ticketId,
			subject: this.subject,
			note: [
				this.linecardDesc,
				this.linecardEl.type,
				this.linecardEl.desc,
				this.form.controls.comment.value,
			].join(separator),
			timestamp: this.dateHelper.getNowISO(),
		} as LinecardElementComment;
		this.linecardService.addChangeComment(comment);

		this.toastSuccess();
		this.dismiss();
	}

	private async toastSuccess(): Promise<void> {
		const toast = await this.toastController.create({
			message: 'Comment saved.',
			duration: 3000,
			position: 'top',
			color: 'success',
			buttons: ['Dismiss'],
		});

		await toast.present();
	}

	async dismiss(): Promise<void> {
		await this.modalController.dismiss({
			dismissed: true,
		});
	}

}
